import { createAuthClient } from "better-auth/client";
import { passkeyClient } from "@better-auth/passkey/client";
export const auth = createAuthClient({ plugins: [passkeyClient()] });
